<template>
  <div class="show" v-if="showInfo">
    
    <div class="boxi">
      <!-- <div class="logo">
          <img src="/static/img/logo21.png" alt="" @click="$router.push('/')">
        </div> -->
      <div class="content">
        <div class="headerinfo">
          <h2>
            企业查询结果
          </h2>
          <a class="back" href="/inquery?inqtype=ry"><img src="/static/img/chaxunicon.png" alt="">
            继续查询</a>
        </div>
        <div class="detailInfo">
          <table>
            <tr>
              <td colspan="4" class="ttitle"><img src="/static/img/zuo.png" alt=""> 企业基本信息<img src="/static/img/you.png" alt=""></td>
            </tr>
            <tr>
              <td>单位名称：</td>
              <td colspan="3">{{ showInfo.qiyename }}</td>
            </tr>
            <tr>
              <td>法定代表人：</td>
              <td colspan="3">{{ showInfo.legalperson }}</td>
            </tr>
            <tr>
              <td>企业类型：</td>
              <td colspan="3">{{ showInfo.qiyetype }}</td>
            </tr>
            <tr>
              <td>企业信用代码：</td>
              <td colspan="3">{{ showInfo.socialcreditcode }}</td>
            </tr>
            <tr>
              <td>注册地址：</td>
              <td colspan="3">{{ showInfo.address}}</td>
            </tr>
          </table>
        </div>
        <div class="detailInfo">
          <table>
            <tr>
              <td colspan="5" class="ttitle"><img src="/static/img/zuo.png" alt=""> 荣誉基本信息<img src="/static/img/you.png" alt=""></td>
            </tr>
           
            <tr>
              <td>荣誉类型：</td>
              <td colspan="4">{{ showInfo.certtype }}</td>
            </tr>
            <tr>
              <td>荣誉名称：</td>
              <td colspan="4">{{ showInfo.certname }}</td>
            </tr>
            <tr>
              <td>荣誉等级：</td>
              <td colspan="4">{{ showInfo.certlevel }}</td>
            </tr>
            <tr>
              <td>签发编号：</td>
              <td colspan="4">{{ showInfo.code }}</td>
            </tr>
            <tr>
              <td>签发时间：</td>
              <td colspan="4">{{ showInfo.certdate }}</td>
            </tr>
            <tr>
              <td>签发单位：</td>
              <td colspan="4">{{ showInfo.regauth}}</td>
            </tr>
            <tr>
              <td>查询网址：</td>
              <td colspan="4">{{ showInfo.regurl}}</td>
            </tr>
            <tr>
              <td>年检记录：</td>
              <td style="width:100px;text-align: center;height: 120px;" >

                <img v-if="arrSprtQys[0]" :src="`/static/img/yinians.jpg`" width="142"/><br/>
                {{arrSprtQys[0]&&arrSprtQys[0].date}}
              </td>
              <td style="width:100px;text-align: center;">
                <img v-if="arrSprtQys[1]" :src="`/static/img/yinians.jpg`" width="142"/><br/>
                {{arrSprtQys[1]&&arrSprtQys[1].date}}
              </td>
              <td style="width:100px;text-align: center;">
                <img v-if="arrSprtQys[2]" :src="`/static/img/yinians.jpg`" width="142"/><br/>
                {{arrSprtQys[2]&&arrSprtQys[2].date}}
              </td>
              <td style="width:100px;text-align: center;">
                <img v-if="arrSprtQys[3]" :src="`/static/img/yinians.jpg`" width="142"/><br/>
                {{arrSprtQys[3]&&arrSprtQys[3].date}}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
/**
 * 企业证书查询系统模版
 */
import { IP_TEST } from '@/config';
const rate = window.outerWidth / 1400
export default {
  metaInfo: {
    title: '培训信息查询结果',
    meta: [
      {
        name: 'viewport', content:
          `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`
      }
    ]
  },
  name: "ShowQy",
  data() {
    return {
      IP_TEST,
      arrSprtQys:[]
    }
  },
  computed:{
    logopic() {
      return this.$store.getters.logopic;
    }
  },
  props: {
    showInfo: Object
  },
  mounted() {
    if(this.showInfo.nianjian)
    {
      let arrtmpsprts=this.showInfo.nianjian.split("##");
     
      for(let i = 0; i < arrtmpsprts.length;i++) {
        this.arrSprtQys[i]={
          title:arrtmpsprts[i].split("||")[0],
          date:arrtmpsprts[i].split("||")[1],
        }
      }
      this.$forceUpdate();
    }
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    formatExcelData(value) {
      let dataStr = this.formatExcel(value);
      if (isNaN(dataStr) && !isNaN(Date.parse(dataStr))) {
          value = new Date(dataStr);
          if (dataStr.indexOf("/") == -1 && dataStr.indexOf("-") == -1)
              value.setDate(value.getDate() + 1);
          value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
          -2
          )}月${("00" + value.getDate()).slice(-2)}日`;
          return value;
      } else {
          if (dataStr.indexOf("年") > -1) {
              var ttDate = dataStr.match(/\d{4}.\d{1,2}.\d{1,2}/gm).toString();
              ttDate = ttDate.replace(/[^0-9]/gm, "-");
              value = new Date(ttDate);
              value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
              return value;
          } else {
              if (!isNaN(dataStr)) {
                  var data = new Date(1900, 0, dataStr);
                  value = data;
                  value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
                  return value;
              } else {
                  return dataStr;
              }
          }
      }
    },
    formatExcel(value) {
        if (!value) {
            return "";
        } else {
            if (typeof value == "string") {
                return value.trim();
            } else {
                return value.toString().trim();
            }
        }
    }
  }
};
</script>
<style scoped>
 .show{
  position: relative;
  width: 100%;
  min-height:100%;
  background-color: #0157C6;
    background-image: url(/static/img/qybg.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position-y: bottom;
    padding-bottom: 100px;
}
.show .boxi{
  width: 1300px;
  margin: auto;
  position: relative;
  top:47px;
}
.show .boxi .logo{
  text-align: center;
}
.content{
  background: linear-gradient(0deg, #4686D9, #0157C6);
  border: 4px solid;
  border-image: linear-gradient(0deg, #1F74E2, #9EC8FF, #1F74E2, #9EC8FF) 4 4;
  box-shadow: 0px 0px 16px 0px #2E52C0;
  margin-top:65px;
  background-color: RGBA(20, 101, 204, 0.8);
background-image: url(/static/img/xian.png);
}
.content .headerinfo{
  
}
.content .headerinfo h2{
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 90px;
  width: 400px;
  margin-left: 41px;
}
.detailInfo{
  width: 1266px;
  padding: 12px 17px 28px 17px;

  border-radius: 5px;
}
.detailInfo .ttitle{
  text-align: center;
  font-size: 20px !important;
font-family: PingFang SC;
font-weight: bold;
letter-spacing: 2px;
}
.detailInfo .ttitle img{
    position: relative;
    top:7px;
    margin: 0 10px;
  }
.detailInfo td{
  border:1px solid  #6497DA;;
  /* padding:5px 15px; */
  min-height: 54px;
  height: 54px;
  padding-left: 32px;
  font-size: 21px;
  line-height: 33px;
  
}
.detailInfo tr td:first-child{
  font-size: 18px;
  color: #FFFFFF;
  font-weight: bold;
  width: 180px;
}
.detailInfo tr td{
  font-size: 18px;
  color: #FFFFFF;
  width: 1010px;
}
.headerinfo .back{
  color: #fff;
    float: right;
    margin-top: -63px;
    margin-right: 20px;
    font-size: 18px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 47px;
    width: 167px;
    height: 47px;
    background: #3D8CF0;
    border-radius: 5px;
    text-align: center;
}
.headerinfo .back img{
  position: relative;
  top:10px;
}
</style>